export default class StatusOptions {
    public reasonRequiredForDecline?= true;
    public ignoreSubmitted?= false;
}